/* eslint-disable no-restricted-syntax */
/* eslint-disable no-bitwise */
export function fromTelegramSource(source: number) {
  return source >>> 0;
}

export function safeAssign<T>(object: T, fromObject: any) {
  if (fromObject) {
    for (const i in fromObject) {
      if (fromObject[i] !== undefined) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        object[i] = fromObject[i];
      }
    }
  }

  return object;
}

export function indexOfAndSplice<T>(array: Array<T>, item: T) {
  const idx = array.indexOf(item);
  const spliced = idx === -1 ? undefined : array.splice(idx, 1);

  return spliced?.[0];
}
